/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var SubBrokerType;

(function (SubBrokerType) {
  SubBrokerType["PARTNER"] = "partner";
  SubBrokerType["BROKER"] = "broker";
})(SubBrokerType || (SubBrokerType = {}));